// === NAVBAR SCROLL ===
const navbar = document.getElementById('navbar');
window.addEventListener('scroll', () => {
  navbar.classList.toggle('scrolled', window.scrollY > 50);
});

// === MOBILE MENU ===
const burger = document.getElementById('burger');
const navLinks = document.getElementById('navLinks');

burger.addEventListener('click', () => {
  const isOpen = navLinks.classList.toggle('open');
  burger.classList.toggle('active');
  burger.querySelector('.burger-label').textContent = isOpen ? 'Fermer' : 'Menu';
});

navLinks.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', () => {
    burger.classList.remove('active');
    navLinks.classList.remove('open');
    burger.querySelector('.burger-label').textContent = 'Menu';
  });
});

// === NAV DROPDOWN ===
document.querySelectorAll('.nav-dropdown-toggle').forEach(toggle => {
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    const dropdown = toggle.closest('.nav-dropdown');
    document.querySelectorAll('.nav-dropdown').forEach(d => {
      if (d !== dropdown) d.classList.remove('open');
    });
    dropdown.classList.toggle('open');
  });
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('.nav-dropdown')) {
    document.querySelectorAll('.nav-dropdown').forEach(d => d.classList.remove('open'));
  }
});

// === HERO SLIDER (homepage only) ===
const slides = document.querySelectorAll('.slide');
const dots = document.querySelectorAll('.slider-dot');

if (slides.length > 0) {
  let currentSlide = 0;
  let sliderInterval;

  function goToSlide(index) {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');
    currentSlide = index;
    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
  }

  function nextSlide() {
    goToSlide((currentSlide + 1) % slides.length);
  }

  function prevSlide() {
    goToSlide((currentSlide - 1 + slides.length) % slides.length);
  }

  function startSlider() {
    sliderInterval = setInterval(nextSlide, 4000);
  }

  function resetSlider() {
    clearInterval(sliderInterval);
    startSlider();
  }

  const nextBtn = document.getElementById('sliderNext');
  const prevBtn = document.getElementById('sliderPrev');

  if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); resetSlider(); });
  if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); resetSlider(); });

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goToSlide(parseInt(dot.dataset.slide));
      resetSlider();
    });
  });

  startSlider();
}

// === GALLERY (studio pages) ===
const mainImage = document.getElementById('mainImage');
const thumbs = document.querySelectorAll('.thumb');

if (mainImage && thumbs.length > 0) {
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImage.style.opacity = 0;
      setTimeout(() => {
        mainImage.src = thumb.dataset.src;
        mainImage.style.opacity = 1;
      }, 200);
    });
  });
}

// === SCROLL ANIMATIONS ===
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const delay = entry.target.dataset.delay || 0;
      setTimeout(() => entry.target.classList.add('visible'), delay);
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

// === COUNTER ANIMATION ===
const counterObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const el = entry.target;
      const target = parseInt(el.dataset.count);
      const duration = 2000;
      const start = performance.now();

      function update(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased) + (target >= 100 ? '+' : '');
        if (progress < 1) requestAnimationFrame(update);
      }

      requestAnimationFrame(update);
      counterObserver.unobserve(el);
    }
  });
}, { threshold: 0.5 });

document.querySelectorAll('[data-count]').forEach(el => counterObserver.observe(el));

// === SMOOTH SCROLL ===
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// === STUDIO SELECTOR ===
const studioSelect = document.getElementById('studio');
const studioPreview = document.getElementById('studioPreview');

if (studioSelect && studioPreview) {
  studioSelect.addEventListener('change', () => {
    const selected = studioSelect.options[studioSelect.selectedIndex];
    const url = selected.dataset.url;
    const img = selected.dataset.img;
    const name = selected.textContent;

    if (url && img) {
      document.getElementById('studioPreviewImg').src = img;
      document.getElementById('studioPreviewImg').alt = name;
      document.getElementById('studioPreviewName').textContent = name;
      document.getElementById('studioPreviewBtn').href = url;
      studioPreview.style.display = 'block';
      studioPreview.style.opacity = '0';
      studioPreview.style.transform = 'translateY(12px)';
      setTimeout(() => {
        studioPreview.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
        studioPreview.style.opacity = '1';
        studioPreview.style.transform = 'translateY(0)';
      }, 10);
    } else {
      studioPreview.style.display = 'none';
    }
  });
}
